import React, { useState } from "react";
import { List, Button, message, Progress } from "antd";
import { DownloadOutlined, LoadingOutlined } from "@ant-design/icons";
import { downloadFile } from "utils";

function FileLists({ fileList }) {
  const [downloadStates, setDownloadStates] = useState({});

  const handleDownload = async (file, fileName, index) => {
    try {
      setDownloadStates(prev => ({ ...prev, [index]: { downloading: true, progress: 0 } }));
      
      await downloadFile(file, fileName, (progress) => {
        setDownloadStates(prev => ({ 
          ...prev, 
          [index]: { downloading: true, progress } 
        }));
      });
      
      setDownloadStates(prev => ({ ...prev, [index]: { downloading: false, progress: 100 } }));
      
      setTimeout(() => {
        setDownloadStates(prev => {
          const newState = { ...prev };
          delete newState[index];
          return newState;
        });
      }, 1000);
    } catch (error) {
      message.error("Failed to download file. Please try again.");
      setDownloadStates(prev => {
        const newState = { ...prev };
        delete newState[index];
        return newState;
      });
    }
  };

  return fileList?.length > 0 ? (
    <List
      dataSource={fileList}
      className="max-h-[130px] overflow-auto"
      renderItem={(file, index) => {
        const fileName = typeof file === "string"
          ? file.substring(file.lastIndexOf("/") + 1)
          : file?.name;
        const downloadState = downloadStates[index];
        const isDownloading = downloadState?.downloading;
        const progress = downloadState?.progress || 0;

        return (
          <List.Item
            actions={[
              <Button 
                size="small" 
                onClick={() => handleDownload(file, fileName, index)}
                disabled={isDownloading}
                icon={isDownloading ? <LoadingOutlined /> : <DownloadOutlined />}
              >
                {isDownloading ? `${progress}%` : 'Download'}
              </Button>,
            ]}
          >
            <div className="flex-1">
            <List.Item.Meta title={fileName} />
              {isDownloading && (
                <Progress 
                  percent={progress} 
                  size="small" 
                  status="active"
                  strokeColor="#7ED957"
                  showInfo={false}
                />
              )}
            </div>
          </List.Item>
        );
      }}
    />
  ) : null;
}

export default FileLists;
